module.exports = __webpack_public_path__ + "static/media/image3.908fd137.png";